// @flow
import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import cx from 'clsx';
import Link from '../Link';
import * as styles from './ProductBlock.module.scss';

const ProductBlock = ({
    link,
    title,
    image,
    onClick,
}) => (
    <Link to={link} className={cx(styles.productBlock, styles.lift)} onClick={onClick}>
        <div className="image">
            {image ? (
                <GatsbyImage
                    image={image}
                    layout="fullWidth"
                    alt={title}
                />

            ) : null}
        </div>
        <p className={styles.productTitle}>{title}</p>
    </Link>
);
export default ProductBlock;
